import { useSocket } from "../../../helpers/socket";
import Live3TCWrapper from "./Live3TCWrapper";

const Main3TCWrapper = ({ config }) => {
    const getResultPlf = config.type === "vnone" ? "mc" : config.type;
    const { socket } = useSocket({ platform: `${getResultPlf}_website` })
    return <Live3TCWrapper socket={socket} config={config} />
}

export default Main3TCWrapper;